import {
  EventType,
  UserNamesTableResultType,
  UserOfEvents,
  UsersTableResultType,
} from 'src/types/services/user-service.type';

const getUsersOfEvent = (usersList: (UserNamesTableResultType | UsersTableResultType)[], eventId: string) => {
  return usersList
    .filter((u: UserNamesTableResultType | UsersTableResultType) => u.userName.toLowerCase() !== 'root')
    .filter((u: UserNamesTableResultType | UsersTableResultType) => {
      if ('userOfEvents' in u) {
        return u.userOfEvents.some((e: UserOfEvents) => e.eventId === eventId);
      } else {
        return u.events.some((e: EventType) => e.id === eventId);
      }
    });
};

export default getUsersOfEvent;
